<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ActiveForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActiveForm from '@/components/settings/stock-registers/active/ActiveForm'

export default {
  name: 'Active',
  components: {
    PageTitle,
    PageRowWrapper,
    ActiveForm
  }
}
</script>
